"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSystemFeesProducts = exports.bulkUpdateProductDetails = exports.getProductEventLogs = exports.getStaleProducts = exports.importProductPrices = exports.getProductsPricesExport = exports.mergeProduct = exports.splitProductToVariant = exports.splitProduct = exports.deleteProduct = exports.updateProduct = exports.addProductasync = exports.getProductById = exports.getInventoryProducts = exports.getFlatProducts = exports.getByProductSearch = exports.getEmptyTaxGroupProducts = exports.getDuplicatesSkuAndBarcode = exports.getProducts = void 0;
const shared_1 = require("@getgreenline/shared");
const events_1 = require("@getgreenline/events");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonToQueryString(json) {
    return Object.keys(json)
        .filter((key) => json[key] !== undefined)
        .map((key) => {
        if (Array.isArray(json[key])) {
            return encodeURIComponent(key) + '=' + JSON.stringify(json[key]);
        }
        else {
            return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
        }
    })
        .join('&');
}
const getProducts = (companyId, searchFilters) => __awaiter(void 0, void 0, void 0, function* () {
    let url = `/api/v1/company/${companyId}/products?`;
    if (searchFilters) {
        url += jsonToQueryString(searchFilters);
    }
    const response = yield shared_1.axios.get(url);
    return response.data;
});
exports.getProducts = getProducts;
const getDuplicatesSkuAndBarcode = (companyId) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `/api/v1/company/${companyId}/products/duplicateProducts`;
    const response = yield shared_1.axios.get(url);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return response.data;
});
exports.getDuplicatesSkuAndBarcode = getDuplicatesSkuAndBarcode;
const getEmptyTaxGroupProducts = (companyId) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `/api/v1/company/${companyId}/products/emptyTaxGroup`;
    const response = yield shared_1.axios.get(url);
    return response.data;
});
exports.getEmptyTaxGroupProducts = getEmptyTaxGroupProducts;
const getByProductSearch = (companyId, searchFilters) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `/api/v1/company/${companyId}/products/search`;
    const response = yield shared_1.axios.get(url, {
        params: searchFilters,
    });
    return response.data.data;
});
exports.getByProductSearch = getByProductSearch;
const getFlatProducts = (companyId, searchFilters) => __awaiter(void 0, void 0, void 0, function* () {
    let url = `/api/v1/company/${companyId}/products/flat?`;
    if (searchFilters) {
        url += jsonToQueryString(searchFilters);
    }
    const response = yield shared_1.axios.get(url);
    return response.data.data;
});
exports.getFlatProducts = getFlatProducts;
const getInventoryProducts = (companyId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v1/company/${companyId}/inventory/products`);
    return response.data.products;
});
exports.getInventoryProducts = getInventoryProducts;
const getProductById = (companyId, productId, includeDeleted) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v1/company/${companyId}/product/${productId}`, {
        params: { includeDeleted },
    });
    return response.data;
});
exports.getProductById = getProductById;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const addProductasync = (companyId, createObject) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.post(`/api/v1/company/${companyId}/products`, createObject);
    return response.data;
});
exports.addProductasync = addProductasync;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const updateProduct = (companyId, productId, updateObject) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.put(`/api/v1/company/${companyId}/products/${productId}`, updateObject);
    return response.data;
});
exports.updateProduct = updateProduct;
const deleteProduct = (companyId, productId) => __awaiter(void 0, void 0, void 0, function* () {
    return yield shared_1.axios.delete(`/api/v1/company/${companyId}/product/${productId}`);
});
exports.deleteProduct = deleteProduct;
const splitProduct = (companyId, productId, name) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.put(`/api/v1/company/${companyId}/product/${productId}/split`, {
        params: { name },
    });
    return response.data;
});
exports.splitProduct = splitProduct;
const splitProductToVariant = (companyId, productId, name) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.put(`/api/v1/company/${companyId}/product/${productId}/splitToVariant`, {
        params: { name },
    });
    return response.data;
});
exports.splitProductToVariant = splitProductToVariant;
const mergeProduct = (companyId, sourceProductId, targetProductId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.put(`/api/v1/company/${companyId}/product/${sourceProductId}/merge/${targetProductId}`);
    return response.data;
});
exports.mergeProduct = mergeProduct;
const getProductsPricesExport = (companyId, searchFilters) => __awaiter(void 0, void 0, void 0, function* () {
    let url = `/api/v1/companies/${companyId}/products/prices?`;
    if (searchFilters) {
        url += jsonToQueryString(searchFilters);
    }
    const response = yield shared_1.axios.get(url);
    return response.data;
});
exports.getProductsPricesExport = getProductsPricesExport;
const importProductPrices = (companyId, payload) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.post(`/api/v1/companies/${companyId}/products/prices`, payload);
    return response.data;
});
exports.importProductPrices = importProductPrices;
const getStaleProducts = (companyId, pagination) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v1/companies/${companyId}/products/stale`, {
        params: {
            limit: pagination.limit,
            offset: pagination.offset,
        },
    });
    return response.data;
});
exports.getStaleProducts = getStaleProducts;
const getProductEventLogs = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const endpoint = `${params.gateway}/event-log/tenants/${params.tenantId}/event-topics/${events_1.EventsV2.EventModels.EventTopics.PRODUCT}`;
    const res = yield shared_1.axios.get(endpoint, {
        params: params.query,
    });
    return res.data;
});
exports.getProductEventLogs = getProductEventLogs;
// All properties updated through importProductPrices are not updatable in bulkUpdateProductDetails
const bulkUpdateProductDetails = (companyId, payload) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.put(`/api/v1/companies/${companyId}/products/bulk`, payload);
    return response.data;
});
exports.bulkUpdateProductDetails = bulkUpdateProductDetails;
const createSystemFeesProducts = (companyId) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield shared_1.axios.post(`/api/v1/companies/${companyId}/products/system-fees`)).data;
});
exports.createSystemFeesProducts = createSystemFeesProducts;
//# sourceMappingURL=products.js.map